export default "__VITE_ASSET__BIcCzpEH__"